export type DeviceType = 'ios' | 'android' | 'desktop' | 'unknown'

export default function useDeviceType(): DeviceType {
  const ua = navigator.userAgent

  if (/iPad|iPhone|iPod/.test(ua)) return 'ios'
  if (/Android/.test(ua)) return 'android'

  const isMobile = /Mobi|webOS|BlackBerry|Opera Mini|IEMobile/.test(ua)
  if (isMobile) return 'unknown'

  return 'desktop'
}
